import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';

import { OnboardingProvider } from '../../context';
import { useInitializeSteps } from '../../hooks/useInitializeSteps';
import { useProxyWizard } from '../../hooks/useProxyWizard';
import { normalizeOnbDataToForm } from '../OwnAI/utils/normalizeOnbDataToForm';

import { layoutSteps, layoutStepsKeys } from './constants';

import type { LayoutDataType } from './types';

const LayoutOwnAIMultiGender_AIO_G: React.FC = () => {
  const { proxyWizard, step } = useProxyWizard(layoutStepsKeys, layoutSteps);
  const { user } = useAccount();

  useInitializeSteps(proxyWizard, layoutStepsKeys);

  const normalizedOnbData = normalizeOnbDataToForm(user?.onboarding_data ?? {});

  const form = useForm<LayoutDataType>({
    defaultValues: {
      gender: user?.onboarding_data.gender || null,
      identify: user?.onboarding_data.identify || null,
      ...normalizedOnbData,
    },
    values: {
      gender: user?.onboarding_data.gender || null,
      identify: user?.onboarding_data.identify || null,
      ...normalizedOnbData,
    },
  });

  const StepComponent = layoutSteps[step as keyof typeof layoutSteps].component;

  return (
    <OnboardingProvider wizard={proxyWizard} steps={layoutSteps}>
      <FormProvider {...form}>
        <StepComponent />
      </FormProvider>
    </OnboardingProvider>
  );
};

export default LayoutOwnAIMultiGender_AIO_G;
